export const POLICY_DOCUMENT_URLS = {
	'PET00_02-24': 'https://assets.ctfassets.net/cy68knbg9g5b/1Uxt0VeH4UkH6cQvMHp46y/716a317098331f695ba8cb7a9258cdac/PET00_02-24.pdf',
	'PET00_07-20': 'https://assets.ctfassets.net/cy68knbg9g5b/4kI2DCP950OJbqJFfdHW8P/69c6f44532c5a030837c58e8f726ccb7/PET00_07-20.pdf',
	'PET00_01-24': 'https://assets.ctfassets.net/cy68knbg9g5b/4QGLy1oo3JrFs7ZROrmCaT/3af54b10865f19b5cc1b6778cfd43efa/PET00_01-24.pdf',
	'PET50_02-24': 'https://assets.ctfassets.net/cy68knbg9g5b/5ks420HXzDvvr9bLjn69FY/1895648c7427474394bba61c70b54d0c/PET50_02-24.pdf',
	'PET00_01-23': 'https://assets.ctfassets.net/cy68knbg9g5b/3VBxIBze9LzEw99K41FZ9I/402bb6b23ee79190d3291b41565aee3d/PET00_01-23_1.pdf'
};

// eslint-disable-next-line no-shadow
export const STATES_POLICY = {
	AK: 'PET00_02-24',
	AL: 'PET00_02-24',
	AR: 'PET00_07-20',
	AZ: 'PET00_02-24',
	CA: 'PET00_07-20',
	CO: 'PET00_07-20',
	CT: 'PET00_07-20',
	DC: 'PET00_01-24',
	DE: 'PET00_01-24',
	FL: 'PET00_02-24',
	GA: 'PET00_07-20',
	HI: 'PET00_07-20',
	IA: 'PET00_02-24',
	ID: 'PET00_02-24',
	IL: 'PET00_02-24',
	IN: 'PET00_02-24',
	KS: 'PET00_07-20',
	KY: 'PET00_02-24',
	LA: 'PET00_02-24',
	MA: 'PET50_02-24',
	MD: 'PET00_02-24',
	ME: 'PET50_02-24',
	MI: 'PET00_02-24',
	MN: 'PET00_07-20',
	MO: 'PET00_02-24',
	MS: 'PET00_02-24',
	MT: 'PET00_02-24',
	NC: 'PET00_07-20',
	ND: 'PET00_02-24',
	NE: 'PET00_01-23',
	NH: 'PET00_02-24',
	NJ: 'PET00_07-20',
	NM: 'PET00_07-20',
	NV: 'PET00_07-20',
	NY: 'PET00_07-20',
	OH: 'PET00_02-24',
	OK: 'PET00_02-24',
	OR: 'PET00_01-24',
	PA: 'PET00_07-20',
	RI: 'PET00_07-20',
	SC: 'PET00_07-20',
	SD: 'PET00_07-20',
	TN: 'PET00_01-24',
	TX: 'PET00_02-24',
	UT: 'PET00_02-24',
	VA: 'PET00_07-20',
	VT: 'PET00_07-20',
	WA: 'PET00_01-23',
	WI: 'PET00_01-24',
	WV: 'PET00_02-24',
	WY: 'PET00_02-24',
	OTHER: 'PET00_07-20'
};
